var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"n2oconcentration"},[_c('table',[_c('tr',[_c('td',{staticClass:"left"},[_c('label',[_vm._v("N"),_c('sub',[_vm._v("2")]),_vm._v("O "+_vm._s(_vm.type))])]),_vm._v(" "),_c('td',{staticClass:"result"},[_c('label',[_vm._v(_vm._s(_vm.concentration)+" "+_vm._s(_vm.units))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }